import { joinClassNames } from "@/lib/classNames";

export type ShellControlVariant = "default" | "ghost" | "outline" | "secondary" | "accent" | "hero-ghost";
export type ShellControlSize = "default" | "sm" | "lg" | "icon" | "nav";

interface ShellControlClassOptions {
  variant?: ShellControlVariant;
  size: ShellControlSize;
  align?: "center" | "start";
  round?: boolean;
  className?: string;
}

const baseClasses = "inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0";

const variantClasses: Record<ShellControlVariant, string> = {
  default: "bg-primary text-primary-foreground hover:bg-primary/90",
  ghost: "hover:bg-accent hover:text-accent-foreground",
  outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
  secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
  accent: "bg-accent text-accent-foreground hover:bg-accent/90",
  "hero-ghost": "text-white/90 hover:bg-white/10 hover:text-white",
};

const sizeClasses: Record<ShellControlSize, string> = {
  default: "h-10 px-4 py-2",
  sm: "h-9 px-3",
  lg: "h-11 px-8",
  icon: "h-10 w-10",
  nav: "h-9 px-2 xl:px-3",
};

export function shellControlClassName({
  variant = "default",
  size,
  align = "center",
  round = false,
  className,
}: ShellControlClassOptions) {
  return joinClassNames(
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    align === "start" ? "justify-start" : "justify-center",
    round ? "rounded-full" : "rounded-md",
    className,
  );
}
